import types from './types';

const initialState = {
  fetchingPhotosForMonth: false,
  photos: {}
};

export const centerGalleryReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_CENTER_PHOTOS_MONTH_REQUEST: {
      return {
        ...state,
        fetchingPhotosForMonth: true
      };
    }
    case types.GET_CENTER_PHOTOS_MONTH_SUCCESS: {
      const { month, year } = action;
      const key = `${year}-${month}`;

      return {
        ...state,
        fetchingPhotosForMonth: false,
        photos: {
          ...state.photos,
          [key]: action.photos
        }
      };
    }
    case types.GET_CENTER_PHOTOS_MONTH_FAILURE: {
      return {
        ...state,
        fetchingPhotosForMonth: false
      };
    }
    default:
      return state;
  }
};
